export class ControleEchantillonEdition {
    static jsonMap = {
        id: { key: 'id', optional: true },
        numero: { key: 'numero', optional: true, default: '' },
        cahier: { key: 'cahier', optional: true, default: '' },
        numeroPassage: { key: 'numeroPassage', optional: true },
        numeroExpertise: { key: 'numeroExpertise', optional: true },
        millesime: { key: 'millesime', optional: true, default: '' },
        produit: { key: 'produit', optional: true, default: '' },
        numeroLot: { key: 'numeroLot', optional: true, default: '' },
        cepage: { key: 'cepage', optional: true, default: '' },
        volume: { key: 'volume', optional: true, default: '' },
        type: { key: 'type', optional: true, default: '' },
        logement: { key: 'logement', optional: true, default: '' },
        contenant: { key: 'contenant', optional: true, default: '' },
        typeConditionnement: { key: 'typeConditionnement', optional: true, default: '' },
        degre: { key: 'degre', optional: true, default: '' },
        numeroDossier: { key: 'numeroDossier', optional: true, default: '' },
        date: { key: 'date', optional: true, default: '' }
    };

    id: number;
    numero: string;
    cahier: string;
    numeroPassage: number;
    numeroExpertise: number;
    millesime: string;
    produit: string;
    numeroLot: string;
    cepage: string;
    volume: string;
    type: string;
    logement: string;
    contenant: string;
    typeConditionnement: string;
    degre: string;
    numeroDossier: string;
    date: string;
}
